// DefenderIcon
// ============
//
// Wave 14ds-v5: PNG via CSS mask-image, eingefärbt mit currentColor.
//
// Geschichte: vorher als `<img>` gerendert (Wave 14ds-v4). Dann der
// User-Report: "die landy logos sind weg oder kaum sichtbar" — weil das
// PNG dunkelblau auf transparentem Hintergrund war und im Dark-Mode-Tile
// (dunkler Pill, dunkler Background) komplett verschwand.
//
// Fix: Bild wird zur Alpha-Maske. Sichtbare Bild-Pixel (alpha > 0) werden
// mit `backgroundColor: currentColor` ausgefärbt. Der Eltern-Container
// (NaviTile-Pill) setzt `text-sky-300`, also läuft der Landy in hellblau
// raus — perfekt sichtbar auf dunklem UND hellem Hintergrund. Konsistent
// mit den restlichen SVG-Icons der NAVI-Page (alle currentColor-gestyled).
//
// Behält die API: `props: ImgHTMLAttributes<HTMLImageElement>` damit alle
// bestehenden Aufrufe (className, width, height, style) ohne Anpassung
// weiter funktionieren. Wird intern als <span> gerendert — width/height
// via CSS-style angewendet wenn als img-Prop übergeben.

import type { ImgHTMLAttributes, CSSProperties } from 'react';

export function DefenderIcon(props: ImgHTMLAttributes<HTMLImageElement>) {
  const { alt = '', style, className, width, height, ...rest } = props;
  const maskStyle: CSSProperties = {
    display: 'inline-block',
    backgroundColor: 'currentColor',
    WebkitMaskImage: 'url(/icons/landy.png)',
    maskImage: 'url(/icons/landy.png)',
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    maskPosition: 'center',
    // Wenn width/height als img-Props übergeben werden (RunsForTrailButton
    // nutzt width={24} height={24}), übersetzen wir die in CSS-Pixel.
    // Tailwind-className (w-10 h-10) bleibt unverändert wirken — wenn
    // beides gesetzt ist, gewinnt der inline-style.
    ...(width != null ? { width: typeof width === 'number' ? `${width}px` : width } : {}),
    ...(height != null ? { height: typeof height === 'number' ? `${height}px` : height } : {}),
    ...style,
  };
  return (
    <span
      className={className}
      style={maskStyle}
      role="img"
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      // Restliche img-Attribute (onClick etc.) durchreichen.
      // Cast nötig weil span!=img — die meisten Event-Handler sind
      // strukturell kompatibel.
      {...(rest as Record<string, unknown>)}
    />
  );
}
